import RouteRenderer from "./views"

const App = () => {
  return <RouteRenderer />
}

export default App
